import { useState } from 'react'
import { Link as ScrollLink } from 'react-scroll'
import Logo from '../../../assets/images/logo.png'
import { useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { Link } from 'react-router-dom'

function Navbar({ usage }: any) {
  const navigate = useNavigate()
  const [showBar, setShowBar] = useState(false)
  return (
    <div className={`navbar flex ${showBar ? 'show' : ''}`}>
      <div className='flex nav-wrapper items-center justify-between '>
        <div className='logo'>
          <img src={Logo} alt='' />
          <Icon
            icon='bx:bx-menu'
            className='menu'
            onClick={() => setShowBar(!showBar)}
          />
        </div>
        <div className='rest flex justify-between items-center'>
          {usage === 'landing' ? (
            <ul className='flex'>
              {/* @ts-ignore */}
              <ScrollLink to='hero' smooth={true} duration={1000}>
                <li>Home</li>
              </ScrollLink>
              {/* @ts-ignore */}
              <ScrollLink to='integration' smooth={true} duration={1000}>
                <li>Integration</li>
              </ScrollLink>
              {/* @ts-ignore */}
              <ScrollLink to='solutions' smooth={true} duration={1000}>
                <li>Solutions</li>
              </ScrollLink>
              {/* @ts-ignore */}
              <ScrollLink
                to='api-listing-container'
                smooth={true}
                duration={1000}
              >
                <li>APIs</li>
              </ScrollLink>
              {/* @ts-ignore */}
              <ScrollLink to='faqs' smooth={true} duration={1000}>
                <li>FAQs</li>
              </ScrollLink>
            </ul>
          ) : (
            <ul className='flex'>
              <Link to='/'>
                <li>Home</li>
              </Link>
              {/* @ts-ignore */}
              <ScrollLink to='faqs' smooth={true} duration={1000}>
                <li>FAQs</li>
              </ScrollLink>
            </ul>
          )}

          <div className='buttons'>
            <button onClick={() => navigate('/login')}>Log In</button>
            <button onClick={() => navigate('/create-account')}>
              Create Account
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Navbar
